/**
 * Wording for the parts of the company profile its administrator still has to define.
 */

import type { CompanyProfilePendingItem } from "@libro-reclamos/contracts/Platform";

/**
 * Plain-language name of each pending item.
 */
export const PendingItemTitles: Readonly<Record<CompanyProfilePendingItem, string>> = Object.freeze(
  {
    BRANDING: "Logo y colores de tu libro",
    CONSUMER_SUPPORT_CHANNEL: "Canal de atención al consumidor",
    CONTACT: "Persona, correo y teléfono de contacto",
    DATA_CONTROLLER: "Responsable de datos personales",
    LEGAL_ADDRESS: "Domicilio legal",
    PRIVACY_POLICY: "Aviso de privacidad (sin él tu libro público no abre)",
  },
);

/**
 * One-line reminder for the workspace banner. The privacy notice leads because
 * it is the only item that keeps the public book closed.
 */
export function PendingProfileSummary(pending: readonly CompanyProfilePendingItem[]): string {
  if (pending.includes("PRIVACY_POLICY")) {
    return "Tu libro de reclamaciones público no abrirá hasta que definas el aviso de privacidad de tu empresa.";
  }
  if (pending.length === 1 && pending[0] === "BRANDING") {
    return "Tu libro de reclamaciones aún usa los colores por defecto. Agrega tu logo y colores.";
  }
  return "Faltan algunos datos de tu empresa para completar tu libro de reclamaciones.";
}
